import { ChevronDownIcon } from 'components/icons/ChevronDownIcon';
import React, { useState } from 'react';

interface DropdownProps {
  handleClick: (e?: any) => void;
  children?: JSX.Element | JSX.Element[];
  DropdownItem: any;
  [key: string]: any;
}

export const Dropdown = ({ menus = [], children, DropdownItem, handleClick, className }: DropdownProps) => {
  const [isExpanded, setExpanded] = useState(false);

  const handleSelect = (index: number) => {
    handleClick(index);
    setExpanded(false);
  };

  const handleToggleExpand = () => {
    setExpanded(!isExpanded);
  };

  return (
    <div className={`relative inline-block text-left font-normal w-full rounded-2xl ${className}`}>
      <div className="w-full h-full" onClick={handleToggleExpand}>
        <div
          className="flex justify-between items-center select-none w-full h-full"
          id="menu-button"
          aria-expanded="true"
          aria-haspopup="true"
        >
          <div className="w-[calc(100%-30px)] truncate rounded-2xl border-0">{children}</div>
          <ChevronDownIcon
            className={`transform absolute right-1 duration-100 inline-block ${
              isExpanded ? '-rotate-180' : 'rotate-0'
            }`}
          />
        </div>
      </div>
      <div className={`${isExpanded ? 'block' : 'hidden'}`}>
        <div
          className="select-none absolute mt-2 w-full right-0 rounded-md max-h-[125px] shadow-dropdown bg-menuBg z-30 overflow-auto py-4"
          role="dropdown"
          aria-orientation="vertical"
          aria-labelledby="dropdown-button"
          tabIndex={-1}
        >
          {menus?.map((el: any, index: number) => (
            <DropdownItem key={`Dropdown-item-${index}`} {...el} handleClick={() => handleSelect(index)} />
            // <Message key={`Dropdown-item-${index}`} {...el} handleClick={() => handleSelect(index)} />
          ))}
          {!menus.length && (
            <>
              <p className="text-center">No match found</p>
            </>
          )}
        </div>
        <div className="fixed top-0 left-0 z-1 w-screen h-screen" onClick={handleToggleExpand} />
      </div>
    </div>
  );
};

export default React.memo(Dropdown);
